import { CommonFlags as c, DefaultColumns, EntityColumn, EntityDefinition } from "@mcurros2/microm";

const columns = () =>
(
    {
        c_proceso_id: new EntityColumn<string>({ name: 'c_proceso_id', type: 'char', length: 20, flags: c.PK, prompt: 'Proceso ID' }),
        vc_email: new EntityColumn<string>({ name: 'vc_email', type: 'char', length: 255, flags: c.Edit, prompt: 'Email' }),
        bt_prueba: new EntityColumn<boolean>({ name: 'bt_prueba', type: 'bit', flags: c.Edit, prompt: 'Prueba' }),
        vc_password: new EntityColumn<string>({ name: 'vc_password', type: 'varchar', length: 255, flags: c.Edit, prompt: 'Password' }),
        ...DefaultColumns()
    }
)

const views = () =>
(
    {
        enrp_brwStandard: { name: 'enrp_brwStandard', keyMappings: { c_detalle_id: 0 } },
    }
)


const lookups = () =>
(
    {       
    }
)

export class EnviarRecibosDetallesProcesarDef extends EntityDefinition {

    columns = columns();
    views = views();
    lookups = lookups();

    constructor() {
        super('EnviarRecibosDetallesProcesar');
    }
}